// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalCustomerController = function ($scope, $rootScope, $routeParams, $http, CustomerExternal, ContractByCustomer, Plan, LedgerEntryByCustomer, LedgerUtils) {
    if ($routeParams.access_token) {
        var accessToken = $routeParams.access_token;
        if (accessToken) {
            $rootScope.accessToken = accessToken;
            $http.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
            localStorage["access_token"] = accessToken;
        }
    }

    $scope.customer = CustomerExternal.get({ externalCustomerId: $routeParams.externalCustomerId }, function () {
        $scope.contracts = $scope.paginator(function (options, callback) {
            return ContractByCustomer.query(options, function (data) {
                callback();
            });
        }, { customerId: $scope.customer.Id }, 100);
        
        $scope.ledgerEntries = $scope.paginator(function (options, callback) {
            return LedgerEntryByCustomer.query(options, function (data) {
                callback();
                LedgerUtils.populateAdditionalDetails($scope.ledgerEntries.items);
                $scope.$digest();
            });
        }, { customerId: $scope.customer.Id }, 100);
    });

    $scope.plansById = {};
    $scope.plans = Plan.query({}, function () {
        for (var i = 0; i < $scope.plans.length; i++) {
            $scope.plansById[$scope.plans[i].Id] = $scope.plans[i];
        }
    });
};
ExternalCustomerController.$inject = ['$scope', '$rootScope', '$routeParams', '$http', 'CustomerExternal', 'ContractByCustomer', 'Plan', 'LedgerEntryByCustomer', 'LedgerUtils'];
